// const LoggedIn = () => import("../components/home/auth/LoggedIn")
const MyPage = () => import("../components/home/MyPage")
const News = () => import("../components/home/News")
const SignUpAndIn = () => import("../components/home/auth/SignUpAndIn")

const path = [
    {
        path: "/",
        name: "/",
        component: SignUpAndIn,
        meta: {title: "トップページ"}
    },
    {
        path: "/news",
        name: "news",
        component: News,
        meta: {title: "expo|お知らせ"}
    },
    {
        path: "/my-page",
        name: "my-page",
        component: MyPage,
        meta: {title: "マイページ"}
    }
]

export default path